module.exports = __webpack_public_path__ + "img/IEC.30709eac.png";